import React from "react";
import Navigation from "./Navigation";
import Home from "./Home";
import Managers from "./Managers";
import Providers from "./Providers";
import Stakers from "./Stakers";
import FAQ from "./FAQ";
import Staking from "./Staking";

function Body(){
    let component
    switch (window.location.pathname) {
        case "/Home":
            component = <Home />
            break;
        case "/Managers":
            component = <Managers />
            break;
        case "/Providers":
            component = <Providers />
            break;
        case "/Stakers":
            component = <Stakers />
            break;
        case "/Staking":
            component = <Staking />
            break;                                     
        case "/FAQ":
            component = <FAQ />
            break;
        default:
        component = <Home />
            break;
    }

    return(

            <div>

                <div className="header">
                <h1><img src="logocropted.png" alt="CTMT Logo" style={{"width":"100px", "height":"100px"}} />Safeyield Crypto Strategist</h1>
                <p><i>Your crypto companion.</i></p>
                </div>

                <div className="navbar">
                    <Navigation />
                </div>    
                <div>{component}</div>        
            
            </div>

        
    )
}

export default Body;